import { useEffect, useState } from 'react'
import { Alert, Button, Card, Form, Spinner } from 'react-bootstrap'
import { IUser } from '../../models/user';
import { useMutation } from 'react-query';
import { useAuth } from '../../context/auth';

type Props = {
    user: IUser
}

function EmailSettings({user} : Props) {
    const [email, setEmail] = useState(user.email);
    const [error, setError] = useState("");

    const {updateUserEmail, cancelEmailChange} = useAuth();
    const { mutateAsync: updateAccountFn, isLoading} = useMutation( updateUserEmail,
        {
            onSuccess: () => { },
            onError: (error) => {
                setError("Unexpected error. Please try again or contact admin.");
            },
        }
    );
    const { mutateAsync: cancelUpdateFn, isLoading: isCancelling} = useMutation( cancelEmailChange,
        {
            onSuccess: () => { },
            onError: (error) => {
                setError("Unexpected error. Please try again or contact admin.");
            },
        }
    );
    const handleSubmit = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        if(!email) {
            setError("Please fill in all required fields");
            return;
        }
        if(email === user.email) {
            return;
        }
        updateAccountFn({email});
    }
    useEffect(()=>{
        if(user) setEmail(user.email)
    }, [user]);

    return (
        <Card className="mb-4 bg-dark text-white border-secondary">
            <Card.Body>
                <Card.Title className="text-white">Update Email</Card.Title>
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="email" className="mb-3">
                        {       
                            user.pendingEmail ? 
                            <Form.Text className="text-light">
                                {/* confirm change of cancel it */}
                                You have requested to change your email to <strong className="text-warning">{user.pendingEmail}</strong>. 
                                Please confirm this change by clicking a confirmation link sent to your new email.
                                If you want to cancel this change, click 
                                <Button variant="link" className="text-primary p-0" onClick={()=>cancelUpdateFn()}>here</Button>.
                                {isCancelling && <Spinner/>}
                            </Form.Text> :
                            <Form.Text className="text-light">
                                If you change this, an email will be sent to your new address to confirm it. 
                                <strong>The new address will not become active until confirmed</strong>.
                            </Form.Text>
                        }
                        <Form.Control 
                            type="email"
                            value={email} 
                            onChange={e => setEmail(e.target.value)}
                            className="bg-dark text-white border-secondary"
                            style={{
                                backgroundColor: '#212529',
                                borderColor: '#6c757d',
                                color: '#ffffff'
                            }} />
                    </Form.Group>
                    {error && (
                        <Alert variant="danger" className="mt-3 bg-danger bg-opacity-25 text-light border-danger">
                            {error}
                        </Alert>
                    )}
                    <Button 
                        type="submit" 
                        variant='primary'
                        disabled={email === user.email}>
                        {isLoading && <Spinner/>} Update
                    </Button>
                </Form>
            </Card.Body>
        </Card>
    )
}

export default EmailSettings